
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/apipages/live/events",
      function () {
        return require("private-next-pages/apipages/live/events/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/apipages/live/events"])
      });
    }
  